import { useQuery } from '@tanstack/react-query';

import { sectorApi } from '../api/sectorApi';

const fetchSector = async () => {
  const data = await sectorApi.listSectors();
  return data.sector || [];
};

export default function useGetAllSectors() {
  return useQuery({
    queryKey: ['listAllSector'],
    queryFn: () => fetchSector(),
    refetchOnWindowFocus: false,
  });
}
